package ai.wagemix.net.models

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/**
 * The stored file behind a mix generated from a job description (`GET /api/v1/jd-file-urls`, by mix id). Both links
 * are signed and expire after a few hours, so they are fetched when needed rather than kept.
 */
interface WMJobDescriptionFile {
    /** The name the file was stored under; a Word upload is stored as the PDF it was converted to. */
    val fileName: String
    /** Opens the file in the browser (for an embedded preview). */
    val previewUrl: String
    /** Saves the file as [fileName] instead of showing it. */
    val downloadUrl: String

    companion object
}

fun WMJobDescriptionFile.Companion.kxs(
    fileName: String,
    previewUrl: String,
    downloadUrl: String
): KxsWMJobDescriptionFile {
    return KxsWMJobDescriptionFile(fileName = fileName, previewUrl = previewUrl, downloadUrl = downloadUrl)
}

fun WMJobDescriptionFile.toKxs(): KxsWMJobDescriptionFile = when (this) {
    is KxsWMJobDescriptionFile -> this
    else -> WMJobDescriptionFile.kxs(fileName = fileName, previewUrl = previewUrl, downloadUrl = downloadUrl)
}

@Serializable
@SerialName("WMJobDescriptionFile")
@ConsistentCopyVisibility
data class KxsWMJobDescriptionFile internal constructor(
    override val fileName: String,
    override val previewUrl: String,
    override val downloadUrl: String
): WMJobDescriptionFile
